import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class RequestCacheService {
  private cache = new Map<string, [Date, HttpResponse<any>]>();

  constructor(private logger: LoggerService) {}

  public get(key: string): HttpResponse<any> {
    const tuple = this.cache.get(key);

    if (!tuple) {
      return null;
    }

    const expires = tuple[0];
    const httpResponse = tuple[1];

    if (expires && expires.getTime() < new Date().getTime()) {
      this.cache.delete(key);
      return null;
    }

    this.logger.info('Using cached response for: ', key);
    return httpResponse;
  }

  public set(key: string, value: HttpResponse<any>, ttl: number = null) {
    if (ttl) {
      const expires = new Date();
      expires.setSeconds(expires.getSeconds() + ttl);
      this.cache.set(key, [expires, value]);
    } else {
      this.cache.set(key, [null, value]);
    }
  }
}
